export const COMPONENT_NAME = 'Tint';
